

// hooks/useAuthorization.js
import { useState, useEffect } from 'react';
import axios from 'axios';

export const useAuthorization = () => {
    const [permissionLevel, setPermissionLevel] = useState(0); // 0, 1, or 2
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAuthorization = async () => {
            try {
                const response = await axios.get('/sso/permissions/', {
                    withCredentials: true,
                });
                const result = response.data;

                if (result.permission_ids && result.permission_ids.length > 0) {
                    // Get the highest permission level from the data
                    const ids = result.permission_ids || [];
                    const permissions = new Set(ids);

                    let derivedLevel = 0;
                    if (permissions.has(1)) {
                        derivedLevel = 2;
                    } else if (permissions.has(2)) {
                        derivedLevel = 1;
                    } else {
                        derivedLevel = 0;
                    }

                    setPermissionLevel(derivedLevel);

                }
            } catch (error) {
                console.error('Authorization check failed:', error);
            } finally {
                setLoading(false);
            }
        };

        checkAuthorization();
    }, []);

    return {
        permissionLevel, // 0, 1, or 2
        isAuthorized: permissionLevel >= 1, // For backward compatibility
        loading
    };
};


